<template>
  <div class="dialog">
    <el-dialog
      :visible.sync="changVisible"
      :title="scanning ? '正在扫描' : '按年级批量扫描'"
      center
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :before-close="$onClose"
      destroy-on-close
    >
      <div class="body_scan body_scan_pro" v-if="scanning">
        <el-progress type="circle" :percentage="scanProgress"></el-progress>
      </div>
      <div class="body_scan" v-else>
        <div class="year">
          <span style="margin-left: 50px">&emsp;入学年份&nbsp;&nbsp;</span>
          <el-select
            class="input"
            v-model="whereYearInput"
            placeholder="请选择"
          >
            <el-option
              v-for="item in yearOptions"
              :key="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>

        <div class="scanAccuracy">
          <span style="margin-left: 50px">扫描准确度*&nbsp;</span>
          <el-select
            class="input"
            v-model="whereRepeatInput"
            placeholder="请选择"
          >
            <el-option
              v-for="item in repeatOptions"
              :key="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>

        <div class="explain">
          <p>*扫描准确度高，扫描出的数据少，相似度高</p>
          <p>扫描准确度低，扫描出的数据多，相似度偏低</p>
          <p>因为扫描出的数据需要手动处理，建议准确度由高到低合理使用</p>
        </div>
      </div>

      <div class="foot">
        <el-button
          v-if="scanning"
          style="width: 106px; float: right"
          size="small"
          type
          @click="stopScan()"
          >取消扫描</el-button
        >
        <!-- <el-button
          v-else
          style="width: 106px; float: right;"
          size="small"
          type="primary"
          @click="startScan()"
        >开始扫描</el-button>-->
      </div>
    </el-dialog>
  </div>
</template>

<script>
var thisIndex;
var thisUserName;
var thisType;
var thisInfo;
export default {
  data() {
    return {
      changVisible: false,
      scanning: false,
      whereYearInput: "",
      yearOptions: [], //入学年份
      whereRepeatInput: "", //重复率
      repeatOptions: [
        // "10%",
        // "20%",
        "30%",
        "40%",
        "50%",
        "60%",
        "70%",
        "80%",
        "90%",
      ], //重复率
      scanProgress: 0,
      intervalTimer: "",
      repeatId: "",
    };
  },
  methods: {
    $onClose(done) {
      this.stopScan();
      done();
    },
    close() {
      this.changVisible = false;
    },
    // 获取入学年份
    getYearOptions: function () {
      this.$api
        .getColumnValue({
          token: localStorage.getItem("token"),
          field: "year",
        })
        .then(({ data }) => {
          console.log(data);
          this.yearOptions = data.Data.year;
        })
        .catch(({ error }) => {
          console.log(error);
        });
    },
    // 开始扫描
    startScan() {
      // if (this.whereRepeatInput == "") {
      //   this.$message.error("请选择扫描准确度");
      //   return;
      // }
      // this.$emit("toStartScan", this.whereYearInput, this.whereRepeatInput);
      this.scanning = true;
      // 计时器为空，操作
      this.intervalTimer = setInterval(() => {
        if (this.scanProgress < 100) {
          // this.scanProgress += 1;
          this.getRepeatSchedule();
        } else {
          this.scanComplete();
          this.$emit("toGetRepeatInfo");
        }
      }, 1000 * 2);
    },
    // 查询扫描更新校友相似度进度
    getRepeatSchedule() {
      this.$api
        .getRepeatSchedule({
          token: localStorage.getItem("token"),
          repeatId: this.repeatId,
        })
        .then(({ data }) => {
          this.scanProgress = parseInt(data.Data.repeatSchedule * 100);
        })
        .catch(({ error }) => {
          console.log(error);
        });
    },
    // 查询扫描更新校友相似度进度
    stopUpdateRepeat() {
      this.$api
        .stopUpdateRepeat({
          token: localStorage.getItem("token"),
          repeatId: this.repeatId,
        })
        .then(({ data }) => {
          console.log(data);
          this.$emit("toStopScan");
          this.scanComplete();
        })
        .catch(({ error }) => {
          console.log(error);
        });
    },
    clearIntervalTimer() {
      clearInterval(this.intervalTimer); //清除计时器
      this.scanProgress = 0;
    },
    // 取消扫描
    stopScan() {
      this.stopUpdateRepeat();
    },
    // 扫描完成
    scanComplete() {
      this.clearIntervalTimer();
      this.changVisible = false;
    },
    //页面初始化时加载的事件
    init(repeatId) {
      this.repeatId = repeatId;
      this.scanning = false;
      this.changVisible = true;
      this.startScan();
    },
  },
};
</script>

<style lang="less" scoped>
.body_scan {
  width: 600px;
  height: 380px;
}
.body_scan_pro {
  display: table-cell;
  text-align: center;
  vertical-align: middle;
}
// 入学年份
.year {
  margin-top: 50px;
  margin-left: 40px;
}
// 扫描准确度
.scanAccuracy {
  margin-top: 40px;
  margin-left: 40px;
}
// 扫描说明
.explain {
  margin-top: 140px;
  margin-left: 40px;
}
.foot {
  width: 100%;
  background-color: #ffffff;
  padding-top: 10px;
  padding-bottom: 10px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/scanDialog.vue